export const SET_STEP = 'SET_STEP'
export const SET_VISITED_STEP = 'SET_VISITED_STEP'
export const RESET_VISITED_STEP = 'RESET_VISITED_STEP'
export const SET_RECOMMENDATIONS = 'SET_RECOMMENDATIONS'
export const SET_RECOMMENDATION = 'SET_RECOMMENDATION'
export const RESET_RECOMMENDATION = 'RESET_RECOMMENDATION'
export const UPDATE_RECOMMENDATION = 'UPDATE_RECOMMENDATION'
export const SET_CRITERIA_CHANGED = 'SET_CRITERIA_CHANGED'
export const PREP_RECOMMENDATION = 'PREP_RECOMMENDATION'
export const RESET_TRANSLATIONS = 'RESET_TRANSLATIONS'
export const SET_TRANSLATIONS = 'SET_TRANSLATIONS'
export const SET_BMS_REPAIRS = 'SET_BMS_REPAIRS'
export const SET_BMS_XML = 'SET_BMS_XML'
export const UPDATE_BMS_REPAIRS = 'UPDATE_BMS_REPAIRS'



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/types.js